<template>
  <form action="">
    <div class="mb-2">
      <label for="exampleFormControlInput2">Nama Principal</label>
      <input
        type="text"
        class="form-control"
        id="exampleFormControlInput2"
        placeholder="company name"
        v-model="form.compname"
      />
    </div>
    <div class="mb-2 text-end">
      <button
        type="button"
        class="btn btn-danger btn-sm m-1"
        @click="$store.commit('Company/SET_FORM', {})"
      >
        <i class="fa-solid fa-circle-xmark"></i> Batal
      </button>
      <button
        type="button"
        class="btn btn-primary btn-sm m-1"
        @click="$store.dispatch('Company/saveCreate')"
      >
        <i class="fa-solid fa-circle-plus"></i> Simpan
      </button>
    </div>
  </form>
</template>
<script>
export default {
  name: "CompanyCreateComponent",
  computed: {
    form: {
      get() {
        return this.$store.state.Company.form;
      },
      set(value) {
        this.$store.commit("Company/SET_FORM", value);
      },
    },
  },
};
</script>
